import { useRouteMatch } from 'react-router-dom';
import routes from '../../routes';

export enum NavigationTab {
    Releases = 'releases',
    Builds = 'builds',
}

export interface AppNavigationTabContext {
    routeBasedTab: NavigationTab | null;

    selectedSubOption: string | null;

    isReleaseCalendarRoute: boolean;
    isTriageRoute: boolean;
    isReleasesRoute: boolean;
    isBuildsRoute: boolean;
    isSharedWithMeRoute: boolean;
    isBucketRoute: boolean;

    bucketIdParam: string | undefined;
}

export const SUB_OPTION_SHARED_WITH_ME = 'shared-with-me';
export const SUB_OPTION_RELEASE_CALENDAR = 'release-calendar';
export const SUB_OPTION_APP_TIMELINE = 'app-timeline';
export const SUB_OPTION_TRIAGE = 'triage';

export function useAppNavigationTabContext(): AppNavigationTabContext {
    const releaseCalendarMatch = useRouteMatch([routes.appReleaseCalendar]);
    const appTimelineMatch = useRouteMatch([routes.appTimeline]);
    const triageMatch = useRouteMatch([routes.appTriage]);
    const releasesMatch = useRouteMatch([routes.app, routes.release]);
    const buildsMatch = useRouteMatch([routes.appBuilds]);
    const sharedWithMeMatch = useRouteMatch([routes.sharedWithMeBucket]);
    const bucketMatch = useRouteMatch<{ bucketIdParam: string }>([routes.appBucket]);

    const isReleaseCalendarRoute = !!releaseCalendarMatch;
    const isTriageRoute = !!triageMatch;
    const isReleasesRoute = !!releasesMatch;
    const isBuildsRoute = !!buildsMatch;
    const isSharedWithMeRoute = !!sharedWithMeMatch;
    const isBucketRoute = !!bucketMatch;

    const bucketIdParam = bucketMatch?.params?.bucketIdParam;

    const routeBasedTab: NavigationTab | null =
        isBucketRoute || isBuildsRoute || isSharedWithMeRoute ? NavigationTab.Builds
        : isReleasesRoute ? NavigationTab.Releases
        : null;

    const isAppTimelineRoute = !!appTimelineMatch;

    const selectedSubOption: string | null =
        isBucketRoute && bucketIdParam ? bucketIdParam
        : isSharedWithMeRoute ? SUB_OPTION_SHARED_WITH_ME
        : isReleaseCalendarRoute ? SUB_OPTION_RELEASE_CALENDAR
        : isAppTimelineRoute ? SUB_OPTION_APP_TIMELINE
        : isTriageRoute ? SUB_OPTION_TRIAGE
        : null;

    return {
        routeBasedTab,
        selectedSubOption,
        isReleaseCalendarRoute,
        isTriageRoute,
        isReleasesRoute,
        isBuildsRoute,
        isSharedWithMeRoute,
        isBucketRoute,
        bucketIdParam,
    };
}
